import { rem } from 'polished'
import { styled } from 'styles/stitches.config'
import { Grid as GridChakra } from '@chakra-ui/react'

import ButtonComponent from "components/Button";


export const Map = styled('div', {
  width: '100%',
  height: 200,
  marginBottom: 50,

  background: '#A7C2B9',

  '@lg': {
    height: 350,
    marginBottom: 112,
  }
})

export const Flex = styled('div', {


  '@lg': {
    display: 'flex',
    justifyContent: 'space-between',
  }
})

export const Left = styled('div', {
  flex: 1,
  marginBottom: 50,

  '@lg': {
    marginBottom: 0,
  },
})

export const Form = styled('form', {
  marginTop: 15,

  '@md': {
    marginTop: 32,
  }
})

export const Grid = styled(GridChakra, {
  gridTemplateColumns: 'repeat(1, 1fr)',

  '@md': {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
})

export const Right = styled('aside', {
  flex: 1,

  '@lg': {
    marginLeft: 94,
    maxWidth: 400,
  }
})

export const Button = styled(ButtonComponent, {
  position: 'relative',

  marginTop: 56,

  '& svg': {
    marginLeft: 5,
    marginTop: '-2px'
  }
})

export const About = styled('div', {
  padding: 16,

  borderRadius: 4,
  background: '$emerald50',
  border: 'solid 1px',
  borderColor: '$emerald500',

  '@lg': {
    padding: 48,
  },

  '& h4': {
    fontSize: '28px !important',
    marginBottom: 40,
  }
})

export const Item = styled('div', {
  display: 'flex',
  alignItems: 'center',

  '&:not(:last-of-type)': {
    paddingBottom: 35,
    marginBottom: 35,
    borderBottom: 'solid 1px',
    borderBottomColor: '$emerald500',
  }
})

export const IconWrap = styled('div', {
  width: 60,
  height: 60,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: 10,

  borderRadius: '100%',
  background: '$emerald100',
})

export const Label = styled('p', {
  fontFamily: '$domine',
  fontWeight: 'bold',
  fontSize: rem(14),
  color: '$grey900',
})

export const Text = styled('p', {
  fontFamily: '$domine',
  fontSize: rem(14),
  color: '$grey600',
  marginLeft: 'auto'
})
